import React, { useState,useEffect } from 'react'
import {
  CTable, CTableHead, CTableBody, CTableRow, CTableHeaderCell, CTableDataCell,
  CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle,
  CForm, CFormInput, CFormSelect, CFormLabel,CFormTextarea
} from '@coreui/react'
import { Pagination } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import './../usefulVideo/usefulVideo.css';
import { useNavigate } from 'react-router-dom';


import { useParams } from 'react-router-dom';

import Swal from 'sweetalert2';
import axios from 'axios'

const slugIdMap = {
  'study-materials': 1,
  'useful-links': 2,
  'useful-videos': 3,
};


const UsefulVideos = () => {
  const { slug } = useParams();
  const [categoryData, setCategoryData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [visible, setVisible] = useState(false)
  const [semesters, setSemesters] = useState([]);
  const [courseCategories, setCourseCategories] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [programs, setPrograms] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState('');

  const [categorySlug, setCategorySlug] = useState('');


  const [paperCodes, setPaperCodes] = useState([])

  const [dataList, setDataList] = useState([]);


  const [shouldOpenModal, setShouldOpenModal] = useState(false);

  // const [searchCourseCategories, setSearchCourseCategories] = useState([]);
  // const [searchSemesters, setSearchSemesters] = useState([]);

  const [showIframeForId, setShowIframeForId] = useState(null);


  const [searchSubjects, setSearchSubjects] = useState([]);
  const [searchPaperCodes, setSearchPaperCodes] = useState([]);


  const [currentPage, setCurrentPage] = useState(1)
  const [perPage] = useState(10)
  const [totalPages, setTotalPages] = useState(1)

  const today = new Date().toISOString().split("T")[0];

  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState(null);

  const [newVideo, setNewVideo] = useState({
  courseCategory: '',
  date: today,
  subject: '',
  title: '',
  semester: '',
  paperCode: '',
  youtubeLink: '',
  file: null,

});


const navigate = useNavigate();

useEffect(() => {
  fetchMaterials(1);
}, [slug]);


useEffect(() => {
  const today = new Date().toISOString().split("T")[0];
  setNewVideo((prev) => ({ ...prev, date: today }));
}, []);






// ✅ Top of your component file
const fetchSubjects = async (courseCategoryId) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post(
      'https://codydealms.codydeasoftech.in/api/teacher/subjects',
      { course_category: courseCategoryId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (res.data.status) {
      setSubjects(res.data.data);
    }
  } catch (err) {
    console.error('Subject fetch failed', err);
  }
};

// const fetchPaperCodes = async () => {
//     if (!newVideo.subject || !newVideo.semester) return;

//     try {
//       const token = localStorage.getItem('token');

//       const response = await axios.post(
//         'https://codydealms.codydeasoftech.in/api/teacher/paperCodes',
//         {
//           subject: newVideo.subject,
//           semester: newVideo.semester,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.data.status) {
//         setPaperCodes(response.data.data);
//       } else {
//         setPaperCodes([]);
//       }
//     } catch (error) {
//       console.error('Error fetching paper codes:', error);
//       setPaperCodes([]);
//     }
//   };

const fetchSemesters = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('https://codydealms.codydeasoftech.in/api/teacher/semesters', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.status) {
          setSemesters(response.data.data.semesters);
        }
      } catch (error) {
        console.error('Failed to fetch semesters:', error);
      }
    };

const fetchCourseCategories = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('https://codydealms.codydeasoftech.in/api/teacher/courseCategories', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.status) {
          setCourseCategories(response.data.data.courseCategories);
        }
      } catch (error) {
        console.error('Error fetching course categories:', error);
      }
    };



   const fetchPrograms = async () => {
      try {
        const token = localStorage.getItem('token') // Get token from localStorage

        const response = await axios.get(
          'https://codydealms.codydeasoftech.in/api/teacher/programs',
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )

        if (response.data.status) {
          setPrograms(response.data.data.programs)
        } else {
          console.error('Failed to fetch programs:', response.data.message)
        }
      } catch (error) {
        console.error('Error fetching programs:', error)
      }
    }





const fetchMaterials = async (page) => {
  try {
    const token = localStorage.getItem('token');
    const categoryId = slugIdMap[slug?.toLowerCase()];

    if (!categoryId) return setDataList([]);

    const payload = {
      page: page.toString(),
      perpage: perPage.toString(),
      studymaterial_category_id: categoryId.toString(),
      searchParam: {},
    };

    const response = await axios.post(
      'https://codydealms.codydeasoftech.in/api/teacher/fetchStudyMaterial',
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.status) {
      const materials = response.data.data?.materials || [];
      const pagination = response.data.data?.pagination;

      setDataList(materials);

      if (pagination) {
        setTotalPages(pagination.last_page || 1);
        setCurrentPage(pagination.page || 1);
        console.log('📄 Current Page:', pagination.page);
        console.log('📊 Total Pages:', pagination.last_page);
      } else {
        setTotalPages(1);
        setCurrentPage(1);
      }
    } else {
      setDataList([]);
    }
  } catch (error) {
    console.error('Error fetching study materials:', error);

    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem('token');

      navigate('/login');
    } else {
      setDataList([]);
    }
  }
};


 useEffect(() => {
  fetchMaterials(currentPage);
}, [currentPage]);


// ✅ Helper function to extract YouTube video ID
const extractYouTubeVideoId = (url) => {
  if (!url) return null;

  // Check if it's an iframe with src
  const srcMatch = url.match(/src=["'](?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([^"']+)["']/);
  if (srcMatch) {
    return srcMatch[1];
  }

  // Check if it's a YouTube watch URL
  const urlMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?]+)/);
  if (urlMatch) {
    return urlMatch[1];
  }

  return null;
};

// ✅ Helper function to get embed URL
const getYouTubeEmbedUrl = (url) => {
  const videoId = extractYouTubeVideoId(url);
  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};


useEffect(() => {
  if (editData && visible) {
    setNewVideo({
      id: editData.id?.toString() || '',
      course: editData.course_id?.toString() || '',
      subject: editData.subject_id?.toString() || '',
      title: editData.title || '',
      youtubeLink: editData.url || '',
      semester: editData.semester_id?.toString() || '',
      paperCode: editData.paper_code_id?.toString() || '',
      date: editData.date || '', // or format if needed
      file: null, // Optional: you can’t prefill file inputs
    });

    // Also prefill selected program if needed
    const selectedProg = programs.find(p => p.id === editData.program_id);
    if (selectedProg) setSelectedProgram(selectedProg);
  }
}, [editData, visible]);


const handleEdit = async (item) => {
  const token = localStorage.getItem('token');

  const payload = {
    page: '1',
    perpage: '10',
    studymaterial_category_id: item.studymaterial_category_id.toString(),
    id: item.id.toString(),
    searchParam: {
      title: '',
      from_date: '',
      to_date: '',
      course_category: '',
      subject: '',
      semester: '',
      papercode: ''
    }
  };

  console.log('🟡 handleEdit triggered for ID:', item.id);
  console.log('📦 Payload being sent to fetchStudyMaterial:', payload);

  try {
    const res = await axios.post(
      'https://codydealms.codydeasoftech.in/api/teacher/fetchStudyMaterial',
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.status) {
      const data = res.data.data;

      console.log('✅ Received edit data:', data);

      const foundSlug = Object.keys(slugIdMap).find(
        (key) => slugIdMap[key] === data.studymaterial_category_id
      );

      setCategorySlug(foundSlug);
      setEditData(data);

      await fetchSemesters();
      await fetchCourseCategories();

      const courseCategoryId = data.course_category_id?.toString() || '';

      await Promise.all([
        fetchSubjects(courseCategoryId),
        fetchPaperCodes(courseCategoryId),
      ]);

      // ✅ Handle Program
      const programObj = programs.find((p) => p.id === Number(data.program_id));
      setSelectedProgram(programObj);

      setNewVideo({
        id: data.id,
        courseCategory: courseCategoryId,
        subject: data.subject_id?.toString() || '',
        semester: data.semester_id?.toString() || '',
        paperCode: data.paper_code_id?.toString() || '',
        title: data.material_title || '',
        date: data.date || '',
        youtubeLink: data.useful_link || data.useful_video_iframe || '',
        file: null,
        program: data.program_id?.toString() || '', // ✅ Set program id
      });

      setShowEditModal(true);
    } else {
      console.warn('❌ API response status false:', res.data.message);
      alert('Failed to fetch material details.');
    }
  } catch (err) {
    console.error('🚨 Error in handleEdit:', err);
    alert('Something went wrong while fetching details.');
  }
};

const handleDelete = async (item) => {
  const token = localStorage.getItem('token');

  const confirm = await Swal.fire({
    title: 'Are you sure?',
    text: `Do you really want to delete "${item.material_title}"?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
  });

  if (confirm.isConfirmed) {
    try {
      const res = await axios.post(
        'https://codydealms.codydeasoftech.in/api/teacher/deleteStudyMaterial',
        { id: item.id.toString() },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status) {
        Swal.fire({
          icon: 'success',
          title: 'Deleted',
          text: 'Study material deleted successfully.',
          timer: 2000,
          showConfirmButton: false,
        });

        // Optionally refresh material list
        fetchMaterials(currentPage);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: res.data.message || 'Failed to delete item.',
        });
      }
    } catch (err) {
      console.error('Delete error:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong. Please try again.',
      });
    }
  }
};





const handleAddClick = async () => {
  setEditData(null);
  setCategorySlug(slug);
    const today = new Date().toISOString().split("T")[0];

  // Reset form values
  setNewVideo({
    id: '',
    program: '',
    courseCategory: '',
    subject: '',
    semester: '',
    paperCode: '',
    title: '',
    date: today,
    youtubeLink: '',
    file: null,
  });

  // Reset program selection if you're tracking it separately
  setSelectedProgram(null);

  // Clear dependent dropdown lists
  setSubjects([]);
  setSemesters([]);
  setPaperCodes([]);

  // Optionally re-fetch master dropdowns
  await fetchPrograms?.();
  await fetchCourseCategories?.();
  await fetchSemesters?.();

  setVisible(true);
};






 useEffect(() => {
    const fetchCategoryDetails = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        const id = slugIdMap[slug]; // Get ID from slug

        const res = await axios.post(
          'https://codydealms.codydeasoftech.in/api/teacher/studymaterialCategoryDetails',
          {
            id: id?.toString(),
            slug,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data.status) {
          setCategoryData(res.data.data); // Contains name, icon_class, etc.
        }
      } catch (error) {
        console.error('Error fetching category details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryDetails();
  }, [slug]);



    useEffect(() => {
    const fetchSemesters = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('https://codydealms.codydeasoftech.in/api/teacher/semesters', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.status) {
          setSemesters(response.data.data.semesters);
        }
      } catch (error) {
        console.error('Failed to fetch semesters:', error);
      }
    };

    fetchSemesters();
  }, []);

  useEffect(() => {
    const fetchCourseCategories = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('https://codydealms.codydeasoftech.in/api/teacher/courseCategories', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.status) {
          setCourseCategories(response.data.data.courseCategories);
        }
      } catch (error) {
        console.error('Error fetching course categories:', error);
      }
    };

    fetchCourseCategories();
  }, []);


  useEffect(() => {
    const fetchSubjects = async () => {
      if (!newVideo.courseCategory) return; // skip if no category

      try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
          'https://codydealms.codydeasoftech.in/api/teacher/subjects',
          {
            course_category: newVideo.courseCategory, // ID as string
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.status) {
          // ✅ FIXED LINE HERE
          setSubjects(response.data.data || []);
        } else {
          setSubjects([]);
        }
      } catch (error) {
        console.error('Error fetching subjects:', error);
        setSubjects([]);
      }
    };

    fetchSubjects();
  }, [newVideo.courseCategory]);


 useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const token = localStorage.getItem('token') // Get token from localStorage

        const response = await axios.get(
          'https://codydealms.codydeasoftech.in/api/teacher/programs',
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )

        if (response.data.status) {
          setPrograms(response.data.data.programs)
        } else {
          console.error('Failed to fetch programs:', response.data.message)
        }
      } catch (error) {
        console.error('Error fetching programs:', error)
      }
    }

    fetchPrograms()
  }, [])


  const fetchPaperCodes = async () => {
    if (!newVideo.subject || !newVideo.semester) return;

    try {
      const token = localStorage.getItem('token');

      const response = await axios.post(
        'https://codydealms.codydeasoftech.in/api/teacher/paperCodes',
        {
          subject: newVideo.subject,
          semester: newVideo.semester,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        setPaperCodes(response.data.data);
      } else {
        setPaperCodes([]);
      }
    } catch (error) {
      console.error('Error fetching paper codes:', error);
      setPaperCodes([]);
    }
  };





 useEffect(() => {


  fetchPaperCodes();
}, [newVideo.subject, newVideo.semester]);


const handleInputChange = (e) => {
  const { name, value } = e.target;

  const keyMap = {
    url: 'youtubeLink', // map "url" field to youtubeLink in state
  };

  const key = keyMap[name] || name;

  if (key === 'paperCode') {
    const selectedPaper = paperCodes.find((p) => p.id === parseInt(value));

    setNewVideo((prev) => ({
      ...prev,
      [key]: value,
      title: selectedPaper
        ? selectedPaper.paper_code_name ?? 'Mri'
        : '',
    }));
  }

  else if (key === 'courseCategory') {
    setNewVideo((prev) => ({
      ...prev,
      [key]: value,
      subject: '',
    }));
  }

  // 🧠 Default case
  else {
    setNewVideo((prev) => ({
      ...prev,
      [key]: value,
    }));
  }
};




  const [searchFilter, setSearchFilter] = useState({
  title: '',
  fromDate: '',
  toDate: '',
  courseCategory: '',
  semester: '',
  paperCode: '',
  subject: '',
  program: ''
});

const resetFilter = () => {
  setSearchFilter({
    title: '',
    fromDate: '',
    toDate: '',
    courseCategory: '',
    semester: '',
    paperCode: '',
    subject: '',
    program: ''
  });

  fetchMaterials(1);
};



const handleSearchSubmit = async (e) => {
  if (e && e.preventDefault) e.preventDefault();
  else console.warn("Event object is missing or malformed");

  const token = localStorage.getItem('token');
  console.log('Token:', token);

  const payload = {
  page: currentPage.toString(),
  perpage: '10',
  studymaterial_category_id: slugIdMap[slug]?.toString() || '',
  searchParam: {
    title: searchFilter.title || '',
    from_date: searchFilter.fromDate || '',
    to_date: searchFilter.toDate || '',
    course_category: searchFilter.courseCategory || '',
    subject: searchFilter.subject || '',
    semester: searchFilter.semester || '',
    papercode: searchFilter.paperCode || '',
    program: searchFilter.program || ''
  },
};


  console.log('Search Payload:', payload);

  try {
    const res = await axios.post(
      'https://codydealms.codydeasoftech.in/api/teacher/fetchStudyMaterial',
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log('Search Response:', res);

    if (res.data.status) {
      const responseData = res.data.data;
      console.log('✅ Data returned:', responseData);
      console.log('Is array:', Array.isArray(responseData));

    setDataList(Array.isArray(responseData.materials) ? responseData.materials : []);
    } else {
      console.warn('❌ Search API returned failure:', res.data.message);
      alert('No results found.');
      setDataList([]);
    }
  } catch (err) {
    console.error('🔥 Error during search API call:', err);
    alert('Something went wrong while searching.');
    setDataList([]);
  }
};


const handleAddVideo = async () => {
  const {
    program,
    courseCategory,
    subject,
    title,
    semester,
    paperCode,
    youtubeLink,
    file,
  } = newVideo;

  let categoryId = null;
  if (categorySlug === 'study-materials') categoryId = 1;
  else if (categorySlug === 'useful-links') categoryId = 2;
  else if (categorySlug === 'useful-videos') categoryId = 3;

const programId = selectedProgram;



 if (!programId || !courseCategory || !subject || !title || !semester || !paperCode) {
  Swal.fire({
    icon: 'warning',
    title: 'Missing Fields',
    text: 'Please fill in all required fields.',
  });
  return;
}

if (categorySlug === 'useful-links' && !youtubeLink) {
  Swal.fire({
    icon: 'warning',
    title: 'Missing Link',
    text: 'Please provide the useful link.',
  });
  return;
}

if (categorySlug === 'useful-videos' && !youtubeLink) {
  Swal.fire({
    icon: 'warning',
    title: 'Missing Video',
    text: 'Please provide the iframe video link.',
  });
  return;
}

if (categorySlug === 'study-materials' && !file) {
  Swal.fire({
    icon: 'warning',
    title: 'Missing File',
    text: 'Please upload a file.',
  });
  return;
}


  const formData = new FormData();
  formData.append('studymaterial_category_id', categoryId);
  formData.append('program_id', selectedProgram.id);
  formData.append('course_category_id', courseCategory);
  formData.append('subject_id', subject);
  formData.append('semester_id', semester);
  formData.append('paper_code_id', Number(paperCode));
  formData.append('material_title', title);
  formData.append('date', newVideo.date);

  if (categorySlug === 'study-materials') {
    formData.append('studymaterial_file', file);
  } else if (categorySlug === 'useful-links') {
    formData.append('useful_link', youtubeLink);
  } else if (categorySlug === 'useful-videos') {
    formData.append('useful_video_iframe', youtubeLink);
  }

  try {
    setLoading(true);
    const token = localStorage.getItem('token');

    const response = await axios.post(
      `https://codydealms.codydeasoftech.in/api/teacher/addEditStudyMaterial`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );


    if (response.data.status) {
      setVisible(false)
      Swal.fire({
        title: 'Submitted Successfully',
        text: response.data.message ,
        icon: 'success',
        showConfirmButton: true,
      });

      fetchMaterials(1);

      setNewVideo({
        program: '',
        courseCategory: '',
        subject: '',
        title: '',
        semester: '',
        paperCode: '',
        youtubeLink: '',
        file: null,
        date: today
      });

    } else {
      alert(response.data.message || 'Something went wrong.');
    }
  } catch (error) {
    console.error('API Error:', error.response || error.message || error);
    alert('An error occurred while submitting.');
  } finally {
    setLoading(false);
  }
};


const handleUpdateVideo = async () => {
  const {
    id,
    program,
    courseCategory,
    subject,
    title,
    semester,
    paperCode,
    youtubeLink,
    file,
    date
  } = newVideo;

  let categoryId = null;
  if (categorySlug === 'study-materials') categoryId = 1;
  else if (categorySlug === 'useful-links') categoryId = 2;
  else if (categorySlug === 'useful-videos') categoryId = 3;

  const programId = program || selectedProgram?.id;

  if (!id) {
    alert("Missing material ID for update.");
    return;
  }


if (categorySlug === 'useful-links' && !youtubeLink) {
  Swal.fire({
    icon: 'warning',
    title: 'Missing Link',
    text: 'Please provide the useful link.',
  });
  return;
}

if (categorySlug === 'useful-videos' && !youtubeLink) {
  Swal.fire({
    icon: 'warning',
    title: 'Missing Video',
    text: 'Please provide the iframe video link.',
  });
  return;
}

// if (categorySlug === 'study-materials' && !file) {
//   Swal.fire({
//     icon: 'warning',
//     title: 'Missing File',
//     text: 'Please upload a file.',
//   });
//   return;
// }


  // 📦 Build FormData
  const formData = new FormData();
  formData.append('id', id);  // ✅ Include ID for update
  formData.append('studymaterial_category_id', categoryId);
  formData.append('program_id', program);
  formData.append('course_category_id', courseCategory);
  formData.append('subject_id', subject);
  formData.append('semester_id', semester);
  formData.append('paper_code_id', Number(paperCode));
  formData.append('material_title', title);
  formData.append('date', date || today);

  // if (categorySlug === 'study-materials') {
  //   formData.append('studymaterial_file', file);
  // } else if (categorySlug === 'useful-links') {
  //   formData.append('useful_link', youtubeLink);
  // } else if (categorySlug === 'useful-videos') {
  //   formData.append('useful_video_iframe', youtubeLink);
  // }

  if (categorySlug === 'study-materials') {
  if (file) {
    formData.append('studymaterial_file', file);
  } else if (editData?.studymaterial_file) {
    formData.append('existing_file_path', editData.studymaterial_file);
  }
} else if (categorySlug === 'useful-links') {
  formData.append('useful_link', youtubeLink);
} else if (categorySlug === 'useful-videos') {
  formData.append('useful_video_iframe', youtubeLink);
}


  try {
    setLoading(true);
    const token = localStorage.getItem('token');


    const response = await axios.post(
      `https://codydealms.codydeasoftech.in/api/teacher/addEditStudyMaterial`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.data.status) {
      setVisible(false);
      setShowEditModal(false);
      Swal.fire({
        title: 'Updated Successfully',
        text: response.data.message,
        icon: 'success',
        showConfirmButton: true,
      });

      fetchMaterials(1);

      setNewVideo({
        program: '',
        courseCategory: '',
        subject: '',
        title: '',
        semester: '',
        paperCode: '',
        youtubeLink: '',
        file: null,
        date: today
      });

    } else {
      alert(response.data.message || 'Something went wrong during update.');
    }
  } catch (error) {
    console.error('Update API Error:', error.response || error.message || error);
    alert('An error occurred while updating.');
  } finally {
    setLoading(false);
  }
};



  const handleFileChange = (e) => {
  const file = e.target.files[0];
  setNewVideo((prev) => ({
    ...prev,
    file: file,
  }));
};



useEffect(() => {
  const fetchPaperCodesForSearch = async () => {
    if (!searchFilter.subject || !searchFilter.semester) return;

    try {
      const token = localStorage.getItem('token');

      const response = await axios.post(
        'https://codydealms.codydeasoftech.in/api/teacher/paperCodes',
        {
          subject: searchFilter.subject,
          semester: searchFilter.semester,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        setSearchPaperCodes(response.data.data || []);
      } else {
        setSearchPaperCodes([]);
      }
    } catch (error) {
      console.error('Error fetching paper codes for search:', error);
      setSearchPaperCodes([]);
    }
  };

  fetchPaperCodesForSearch();
}, [searchFilter.subject, searchFilter.semester]);

useEffect(() => {
  const fetchSearchSubjects = async () => {
    if (!searchFilter.courseCategory) return;

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'https://codydealms.codydeasoftech.in/api/teacher/subjects',
        {
          course_category: searchFilter.courseCategory,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        setSearchSubjects(response.data.data || []);
      } else {
        setSearchSubjects([]);
      }
    } catch (error) {
      console.error('Error fetching search subjects:', error);
      setSearchSubjects([]);
    }
  };

  fetchSearchSubjects();
}, [searchFilter.courseCategory]);




const handleSearchFilterChange = (e) => {
  const { name, value } = e.target;

  // Convert strings to Date objects for comparison
  const newFromDate = name === 'fromDate' ? new Date(value) : new Date(searchFilter.fromDate);
  const newToDate = name === 'toDate' ? new Date(value) : new Date(searchFilter.toDate);

  if (newFromDate > newToDate) {
    Swal.fire({
      icon: 'warning',
      title: 'Invalid Date Range',
      text: 'To Date must be greater than or equal to From Date.',
    });
    return;
  }

  setSearchFilter((prev) => ({
    ...prev,
    [name]: value,
  }));
};


if (loading) return (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="text-center">
      <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
);   if (!categoryData) return <div className="text-danger">No data found!</div>;

  return (
  <div className="container px-1  mx-auto" style={{maxWidth: "1462px"}}>
    <h4 className="my-4 fw-bold">{categoryData.name}</h4>

<div className="d-flex justify-content-center">
 <div className="card bg-white mb-4 p-4">

<h4 className='fw-bold'>
  Search{" "}
  {slug === "useful-links"
    ? "Useful Links List"
    : slug === "useful-videos"
    ? "Useful Videos List"
    : "Study Material List"}
</h4>
      <div className='row gy-3'>

        {/* Title Field */}
        {/* <div className='col-12 col-sm-6 col-md-3'>
          <label className='form-label'>Title</label>
          <input
            className='form-control'
            type='text'
            value={searchFilter.title}
            placeholder='Enter Title'
            onChange={(e) =>
              setSearchFilter({ ...searchFilter, title: e.target.value })
            }
          />
        </div> */}

        {/* From Date */}
        <div className='col-12 col-sm-6 col-md-3'>
          <CFormLabel>From Date</CFormLabel>
          <input
            type="date"
            name="fromDate"
            className="form-control"
            value={searchFilter.fromDate}
            onChange={handleSearchFilterChange}
          />
        </div>

        {/* To Date */}
        <div className='col-12 col-sm-6 col-md-3'>
          <CFormLabel>To Date</CFormLabel>
          <input
            type="date"
            name="toDate"
            className="form-control"
            value={searchFilter.toDate}
            onChange={handleSearchFilterChange}
          />
        </div>

        {/* program Dropdown */}
        <div className='col-12 col-sm-6 col-md-3'>
          <CFormLabel>Program</CFormLabel>
          <CFormSelect
            name="program"
            value={searchFilter.program}
            onChange={(e) =>
              setSearchFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }))
            }
            options={[
              { label: 'Select program', value: '' },
              ...programs.map((program) => ({
                label: program.program_master_code,
                value: program.id,
              })),
            ]}
          />
        </div>

        {/* Course Category Dropdown */}
        <div className='col-12 col-sm-6 col-md-3'>
          <CFormLabel>Course Category</CFormLabel>
          <CFormSelect
            name="courseCategory"
            value={searchFilter.courseCategory}
            onChange={(e) =>
              setSearchFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }))
            }
            options={[
              { label: 'Select Course Category', value: '' },
              ...courseCategories.map((cat) => ({
                label: cat.name,
                value: cat.id,
              })),
            ]}
          />
        </div>

        {/* Semester */}
        <div className='col-12 col-sm-6 col-md-3'>
          <CFormLabel>Semester</CFormLabel>
          <CFormSelect
            name="semester"
            value={searchFilter.semester}
            onChange={(e) =>
              setSearchFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }))
            }
            options={[
              { label: 'Select Semester', value: '' },
              ...semesters.map((sem) => ({
                label: sem.full_name,
                value: sem.id,
              })),
            ]}
          />
        </div>

        {/* Subject */}
        <div className='col-12 col-sm-6 col-md-3'>
          <CFormLabel>Subject</CFormLabel>
          <CFormSelect
            name="subject"
            value={searchFilter.subject}
            onChange={(e) =>
              setSearchFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }))
            }
            options={[
              { label: 'Select Subject', value: '' },
              ...searchSubjects.map((sub) => ({
                label: sub.name,
                value: sub.id.toString(),
              })),
            ]}
          />
        </div>

        {/* Paper Code */}
        <div className='col-12 col-sm-6 col-md-3'>
          <CFormLabel>Paper Code</CFormLabel>
          <CFormSelect
            name="paperCode"
            value={searchFilter.paperCode}
            onChange={handleSearchFilterChange}
          >
            <option value="">Select Paper Code</option>
            {searchPaperCodes.map((code) => (
              <option key={code.id} value={code.id}>
                {code.name || code.paper_code || 'Unnamed'}
              </option>
            ))}
          </CFormSelect>
        </div>

            <div  className='col-12 col-sm-6 col-md-3'></div>



        {/* Submit Button */}
        <div className=' col-md-2 mt-3'>
          <button className='btn btn-primary w-100 w-md-auto' onClick={handleSearchSubmit}>
            <i class="fa-solid fa-magnifying-glass"></i> Search
          </button>
        </div>

        {/* <div className='col-md-2 mt-3'>
  <button className='btn btn-primary w-100 w-md-auto' onClick={handleSearchSubmit}>
    <i className="fa-solid fa-magnifying-glass"></i>
    Search {slug === "useful-links"
      ? "Link List"
      : slug === "useful-videos"
      ? "Video List"
      : "Material List"}
  </button>
</div> */}


        <div className=' col-md-2 mt-3'>
          <button className='btn btn-secondary w-100 w-md-auto' onClick={resetFilter}>
            <i class="fa-solid fa-rotate-left"></i> Reset
          </button>
        </div>

      </div>
    </div>
</div>





    <div className="d-flex justify-content-between align-items-center flex-wrap mb-2">
      <CButton
  color="success"
  className="text-white fw-bold px-4"
  onClick={handleAddClick}
>
  Add {categoryData.name} <i className="fa-solid fa-plus ms-2"></i>
</CButton>

    </div>

  {loading ? (
      <div className="text-center my-5">
        <div className="d-flex flex-column align-items-center">
          <div className="spinner-border text-primary" role="status"></div>
          <span className="mt-2">Fetching Data...</span>
        </div>
      </div>
      ) : (

    <div className="card d-flex">
      <div style={{ overflowX: 'auto', width: '100%', maxWidth: '100vw' }}>
        <div style={{ minWidth: '900px' }}>
          <CTable hover align="middle">
            <CTableHead color="primary">
              <CTableRow>
                <CTableHeaderCell className='text-center'>Sl No</CTableHeaderCell>
                <CTableHeaderCell>Title</CTableHeaderCell>

                <CTableHeaderCell>Program</CTableHeaderCell>
                <CTableHeaderCell>Category</CTableHeaderCell>

                <CTableHeaderCell>Subject</CTableHeaderCell>

                <CTableHeaderCell>Paper Code</CTableHeaderCell>
              <CTableHeaderCell className='text-center'>
                {slug === 'useful-videos'
                  ? 'Video Link'
                  : slug === 'useful-links'
                  ? 'Useful Link'
                  : 'File'}
              </CTableHeaderCell>
                <CTableHeaderCell>Actions</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {dataList.map((item, index) => (
                <CTableRow key={item.id || index}>
                  <CTableHeaderCell scope="row" className='text-center'>{index + 1}.</CTableHeaderCell>
                          <CTableDataCell>{item.material_title}</CTableDataCell>

                  <CTableDataCell>{item.program_code}</CTableDataCell>
                  <CTableDataCell>{item.course_category_name}</CTableDataCell>

                  <CTableDataCell>{item.subject_name}</CTableDataCell>

                  <CTableDataCell>{item.paper_code}</CTableDataCell>






          <CTableDataCell className='text-center'>
  {slug === 'useful-videos' && item.useful_video_iframe ? (
    (() => {
      const embedUrl = getYouTubeEmbedUrl(item.useful_video_iframe);
      return embedUrl ? (
        <a
          href={`https://www.youtube.com/watch?v=${extractYouTubeVideoId(item.useful_video_iframe)}`}
          target="_blank"
          rel="noreferrer"
          style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  color: '#ff0000',
                  fontSize: '30px',
                }}
        >
                    <i class="fa-brands fa-youtube"></i>

        </a>
      ) : (
        <span className="text-muted">Invalid URL</span>
      );
    })()
  ) : slug === 'useful-links' && item.useful_link ? (
    <a href={item.useful_link} target="_blank" rel="noreferrer" >
          <i class="fa-solid fa-square-arrow-up-right fa-2xl"></i>
    </a>
  ) : slug === 'study-materials' && item.studymaterial_file_full_path ? (
    <a href={item.studymaterial_file_full_path} target="_blank" rel="noreferrer" >
      <i className="fa-solid fa-file-arrow-down me-1 fa-2xl"></i>
    </a>
  ) : (
    'N/A'
  )}
</CTableDataCell>


                  <CTableDataCell>
                    <CButton color="success" size="sm" className="me-2 text-white" onClick={() => handleEdit(item)}><i class="fa-solid fa-pencil"></i></CButton>
                    {/* <CButton color="danger" size="sm" className="text-white"><i class="fa-solid fa-trash-can"></i></CButton> */}

          <CButton
            color="danger"
            size="sm"
            className="text-white"
            onClick={() => handleDelete(item)}
          >
            <i className="fa-solid fa-trash-can"></i>
          </CButton>


                  </CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
        </div>
      </div>
    </div>
  )}



{totalPages > 1 && (
  <Pagination className="justify-content-center mt-3">

    {/* Previous Button */}
    <Pagination.Prev
      disabled={currentPage === 1}
      onClick={() => {
        if (currentPage > 1) fetchMaterials(currentPage - 1);
      }}
    />

    {/* Page Numbers */}
    {Array.from({ length: totalPages }, (_, index) => {
      const pageNum = index + 1;
      return (
        <Pagination.Item
          key={pageNum}
          active={currentPage === pageNum}
          onClick={() => fetchMaterials(pageNum)}
        >
          {pageNum}
        </Pagination.Item>
      );
    })}

    {/* Next Button */}
    <Pagination.Next
      disabled={currentPage === totalPages}
      onClick={() => {
        if (currentPage < totalPages) fetchMaterials(currentPage + 1);
      }}
    />
  </Pagination>
)}




{/* Edit modal */}
<CModal visible={showEditModal} onClose={() => setShowEditModal(false)}
size="lg"
  alignment="center" backdrop="static" keyboard={false}
  scrollable>
  <CModalHeader closeButton  style={{backgroundColor: "#5856d6",color: '#fff'}}>
    <CModalTitle>Edit {categoryData.name}
</CModalTitle>
  </CModalHeader>
  <CModalBody>
  <CForm className="row">
    <div className="mb-3 col-md-6 fw-bold">
      <CFormLabel>Date <span className="text-danger">*</span></CFormLabel>
      <CFormInput
        type="date"
        value={newVideo.date}
        onChange={(e) => setNewVideo({ ...newVideo, date: e.target.value })}
      />
    </div>




    <div className="mb-3 col-md-6 fw-bold">
      <CFormLabel>Program <span className="text-danger">*</span></CFormLabel>
      <CFormSelect
        id="editProgramSelect"
        value={selectedProgram?.id || ''}
        onChange={(e) => {
          const selected = programs.find((p) => p.id === parseInt(e.target.value));
          setSelectedProgram(selected);
          setNewVideo((prev) => ({ ...prev, program: selected?.id }));
        }}
      >
        <option value="">Select Program</option>
        {programs.map((program) => (
          <option key={program.id} value={program.id}>
            {program.program_master_code}
          </option>
        ))}
      </CFormSelect>
    </div>

    <div className="mb-3 col-md-6 fw-bold">
      <CFormLabel>Course Category <span className="text-danger">*</span></CFormLabel>
      <CFormSelect
        value={newVideo.courseCategory}
        onChange={(e) =>
          setNewVideo({ ...newVideo, courseCategory: e.target.value })
        }
      >
        <option value="">Select Course</option>
        {courseCategories.map((item) => (
          <option key={item.id} value={String(item.id)}>
            {item.name}
          </option>
        ))}
      </CFormSelect>
    </div>

    <div className="mb-3 col-md-6 fw-bold">
      <CFormLabel>Subject <span className="text-danger">*</span></CFormLabel>
      <CFormSelect
        value={newVideo.subject}
        onChange={(e) => setNewVideo({ ...newVideo, subject: e.target.value })}
      >
        <option value="">Select Subject</option>
        {subjects.map((item) => (
          <option key={item.id} value={item.id.toString()}>
            {item.name}
          </option>
        ))}
      </CFormSelect>
    </div>

    <div className="mb-3 col-md-6 fw-bold">
      <CFormLabel>Semester <span className="text-danger">*</span></CFormLabel>
      <CFormSelect
        value={newVideo.semester}
        onChange={(e) => setNewVideo({ ...newVideo, semester: e.target.value })}
      >
        <option value="">Select Semester</option>
        {semesters.map((item) => (
          <option key={item.id} value={String(item.id)}>
            {item.full_name}
          </option>
        ))}
      </CFormSelect>
    </div>



    {/* <div className="mb-3 col-md-6 fw-bold">
      <CFormLabel>Paper Code <span className="text-danger">*</span></CFormLabel>
      <CFormSelect
        value={newVideo.paperCode}
        onChange={(e) => setNewVideo({ ...newVideo, paperCode: e.target.value })}
      >
        <option value="">Select Paper Code</option>
        {paperCodes.map((item) => (
          <option key={item.id} value={item.id}>
            {item.paper_code}
          </option>
        ))}
      </CFormSelect>
    </div> */}

    <div className="mb-3 col-md-6 fw-bold">
  <CFormLabel>
    Paper Code <span className="text-danger">*</span>
  </CFormLabel>
  <CFormSelect
    value={newVideo.paperCode}
    onChange={(e) => {
      const selectedId = parseInt(e.target.value);
      const selectedPaper = paperCodes.find((p) => p.id === selectedId);

      setNewVideo((prev) => ({
        ...prev,
        paperCode: selectedId,
        title: selectedPaper
          ? selectedPaper.paper_code_name ?? ''
          : '', // auto-fill the paper name field
      }));
    }}
  >
    <option value="">Select Paper Code</option>
    {paperCodes.map((item) => (
      <option key={item.id} value={item.id}>
        {item.paper_code}
      </option>
    ))}
  </CFormSelect>
</div>




    <div className="mb-3 col-md-12 fw-bold">
      <CFormLabel>Paper Name <span className="text-danger">*</span></CFormLabel>
      <CFormInput
        value={newVideo.title}
        onChange={(e) => setNewVideo({ ...newVideo, title: e.target.value })}
      />
    </div>

    {categorySlug === 'study-materials' && (

     <div className="mb-3 fw-bold">
  <CFormLabel>Upload File</CFormLabel>
  <div className="row align-items-center">
    <div className="col-md-9">
      <CFormInput
        type="file"
        accept="application/pdf"
        onChange={(e) =>
          setNewVideo({ ...newVideo, file: e.target.files[0] })
        }
      />
    </div>

    {editData?.studymaterial_file_full_path && (
      <div className="col-md-3">
        <a
          href={editData.studymaterial_file_full_path}
          target="_blank"
          rel="noreferrer"
          className="btn btn-outline-primary w-100 d-flex justify-content-center align-items-center"
        >
          <i className="fa-solid fa-file-arrow-down fa-lg me-2"></i>
          <span>Previous File</span>
        </a>
      </div>
    )}
  </div>
</div>





    )}

    {/* {categorySlug === 'useful-links' && (
      <div className="mb-3 col-md-12 fw-bold">
        <CFormLabel>Useful Link</CFormLabel>
        <CFormInput
          type="text"
          value={newVideo.youtubeLink}
          onChange={(e) =>
            setNewVideo({ ...newVideo, youtubeLink: e.target.value })
          }
        />
      </div>
    )} */}

    {categorySlug === 'useful-links' && (
  <div className="mb-3 col-md-12 fw-bold">
    <CFormLabel>Useful Link</CFormLabel>
    <div className="row">
      <div className="col-md-9">
        <CFormInput
          type="text"
          value={newVideo.youtubeLink}
          onChange={(e) =>
            setNewVideo({ ...newVideo, youtubeLink: e.target.value })
          }
          placeholder="Paste useful link here"
        />
      </div>

      {newVideo.youtubeLink && (
        <div className="col-md-3">
          <a
            href={newVideo.youtubeLink}
            target="_blank"
            rel="noreferrer"
            className="btn btn-outline-primary w-100 d-flex justify-content-center align-items-center"
          >
            <i className="fa-solid fa-square-arrow-up-right fa-lg me-2"></i>
            <span>Go to Link</span>
          </a>
        </div>
      )}
    </div>
  </div>
)}


    {categorySlug === 'useful-videos' && (
  <div className="mb-3 col-md-12 fw-bold">
    <CFormLabel>YouTube Embed Link</CFormLabel>
    <CFormTextarea
      rows={3}
      value={newVideo.youtubeLink}
      onChange={(e) =>
        setNewVideo({ ...newVideo, youtubeLink: e.target.value })
      }
    />
  </div>
)}

  </CForm>
</CModalBody>

  <CModalFooter>
    <CButton color="secondary" onClick={() => setShowEditModal(false)}>
      Cancel
    </CButton>
    <CButton color="primary" onClick={() => handleUpdateVideo()}>
      Update
    </CButton>
  </CModalFooter>
</CModal>




















    {/*Add Modal */}
    <CModal
  visible={visible}
  onClose={() => {
    setVisible(false);
    setShouldOpenModal(false);
    setEditData(null);
    setCategorySlug('');
  }}
  backdrop="static"
  keyboard={false}
  size="lg"
  alignment="center"
  scrollable
>
      <CModalHeader style={{backgroundColor: "#5856d6"}}>
        {/* <CModalTitle className='text-white'>Add {categoryData.name}</CModalTitle> */}
        <CModalTitle className='text-white'>
  Add {categoryData.name}
</CModalTitle>

      </CModalHeader>
      <CModalBody>
        <CForm>
          <div className="row">

            {/* <div className="mb-3 col-md-6 fw-bold">
  <CFormLabel>Date <span className="text-danger">*</span></CFormLabel>
  <CFormInput
    type="date"
    name="date"
    value={newVideo.date}
    onChange={handleInputChange}
    placeholder="Select Date"
  />
</div> */}

 <div className="mb-3 col-md-6 fw-bold">
  <CFormLabel>
    Date <span className="text-danger">*</span>
  </CFormLabel>
  <CFormInput
  type="date"
  name="date"
  value={newVideo.date}
  onChange={handleInputChange}
  placeholder="Select Date"
/>


</div>
              <div className="mb-3 col-md-6 fw-bold">
                <CFormLabel>Program <span className="text-danger">*</span></CFormLabel>
                <CFormSelect
  id="programSelect"
  value={selectedProgram?.id || ''}
  onChange={(e) => {
    const selected = programs.find((p) => p.id === parseInt(e.target.value));
    setSelectedProgram(selected);
  }}
>
  <option value="">Select Program</option>
  {programs.map((program) => (
    <option key={program.id} value={program.id}>
      {program.program_master_code}
    </option>
  ))}
</CFormSelect>

              </div>

              <div className="mb-3 col-md-6 fw-bold">
            <CFormLabel>Course Category <span className="text-danger">*</span></CFormLabel>
            <CFormSelect
              name="courseCategory"
              value={newVideo.courseCategory}
              onChange={handleInputChange}
              options={[
                { label: 'Select Course Category', value: '' },
                ...courseCategories.map((cat) => ({
                  label: cat.name,
                  value: cat.id,
                })),
              ]}
            />
          </div>


              {/* Subject Dropdown */}
            <div className="mb-3 col-md-6 fw-bold">
            <CFormLabel>Subject <span className="text-danger">*</span></CFormLabel>
            <CFormSelect
              name="subject"
              value={newVideo.subject}
              onChange={handleInputChange}
              options={[
                { label: 'Select Subject', value: '' },
                ...subjects.map((sub) => ({
                  label: sub.name,
                  value: sub.id.toString(),
                })),
              ]}
            />
          </div>


              <div className="mb-3 col-md-6 fw-bold">
            <CFormLabel>Semester <span className="text-danger">*</span></CFormLabel>
            <CFormSelect
  value={newVideo.semester}
  onChange={(e) => setNewVideo({ ...newVideo, semester: e.target.value })}
>
  <option value="">Select Semester</option>
  {semesters.map((item) => (
    <option key={item.id} value={item.id}>
      {item.full_name}
    </option>
  ))}
</CFormSelect>

          </div>


  <div className="mb-3 col-md-6 fw-bold">
  <CFormLabel>Paper Code <span className="text-danger">*</span></CFormLabel>
  <CFormSelect
    name="paperCode"
    value={newVideo.paperCode}
    onChange={handleInputChange}
    options={[
      { label: 'Select Paper Code', value: '' },
      ...paperCodes.map((p) => ({
        label: p.paper_code,
        value: p.id,
      })),
    ]}
  />
</div>






              <div className="mb-3 col-md-12 fw-bold">
                <CFormLabel>Paper Name <span className="text-danger">*</span></CFormLabel>
                <CFormInput
                  name="title"
                  value={newVideo.title}
                  onChange={handleInputChange}
                  placeholder="Enter Paper Name"
                />
              </div>




  {/* Show File Upload if slug === 'study-materials' */}
  {categorySlug === 'study-materials' && (
    <div className="mb-3 col-md-12 fw-bold">
      <CFormLabel>Upload File (PDF) <span className="text-danger">*</span></CFormLabel>
      <CFormInput
        type="file"
        name="file"
        accept=".pdf,.doc,.docx,.ppt,.pptx"
        onChange={handleFileChange}
      />
    </div>
  )}

  {/* Show Link if slug === 'useful-links' */}
  {categorySlug === 'useful-links' && (
    <div className="mb-3 col-md-12 fw-bold">
        <CFormLabel>Useful Link (URL) <span className="text-danger">*</span></CFormLabel>
        <CFormInput
          name="url"
          value={newVideo.youtubeLink}
          onChange={handleInputChange}
          placeholder="Enter valid URL"
          type="text"
        />
    </div>
  )}

  {/* Show YouTube iframe if slug === 'useful-videos' */}
  {categorySlug === 'useful-videos' && (
    <div className="mb-3 col-md-12 fw-bold">
  <CFormLabel>YouTube Embed Iframe URL <span className="text-danger">*</span></CFormLabel>
  <CFormTextarea
    name="url"
    value={newVideo.youtubeLink}
    onChange={handleInputChange}
    placeholder="Paste YouTube embed URL"
    rows={3}
  />
</div>

  )}
            </div>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton color="danger" className='text-white' onClick={() => setVisible(false)}>
          Cancel
        </CButton>
        {/* <CButton color="success" className='text-white' onClick={handleAddVideo}>
          Submit
        </CButton> */}

        <CButton color="success" className='text-white' onClick={handleAddVideo}>
          Submit
        </CButton>

      </CModalFooter>
    </CModal>
  </div>
)

}

export default UsefulVideos
